import styled from "styled-components";
import { Text } from "../../../services/visualLibraryService";
import { BlockStyled } from "../../../styles/shared-styles";

export const VoucherRedemptionPageStyled = styled.section`
  padding: ${props => props.theme.baseLayoutPaddingBs * 2}% ${props => props.theme.baseLayoutPaddingBs}%;
`;

export const TextHeadingStyled = styled(Text)`
  width: 40%;
`;

export const BlockSignupStyled = styled(BlockStyled)`
  width: 34vw;
`;

export const TextLabelStyled = styled(Text)`
  font-size: ${props => props.theme.font.size.medium};
  color: ${props => props.theme.color.tertiary};
  margin-top: ${props => props.theme.spacing.xsmall};
`;
